import {
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import MobiledataOffIcon from '@mui/icons-material/MobiledataOff';

import FilterButton from '../shared/FilterButton';
import ExportToCsv from '../../Helpers/CsvExport';

export default function CustomCustomerToolbar({
  updateOnclick,
  filterOnClick,
  modalState,
}) {
  return (
    <>
      <Typography
        variant='h6'
        align='center'
        xs={{
          background: '#ebedf8',
          margin: '0 auto',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
          textAlign: 'center',
          align: 'center',
        }}
      >
        Customer List By Customer Name
      </Typography>
      <GridToolbarContainer>
        <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
        <Button
          size='small'
          onClick={() => updateOnclick()}
          startIcon={<RefreshIcon />}
        >
          Refresh Data
        </Button>
        <FilterButton filterOnClick={filterOnClick} modalState={modalState} />
        <Button
          size='small'
          onClick={async () => {
            await new ExportToCsv('customer_list').Download();
          }}
          startIcon={<MobiledataOffIcon />}
        >
          Full export
        </Button>
        <GridToolbarQuickFilter
          // autoFocus
          placeholder
          debounceMs={1000}
          sx={{
            right: { sm: 0 },
            position: { sm: 'absolute' },
            marginRight: { sm: '10px' },
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
